import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";

import { environment } from "@env";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class CsrfService {
  private http = inject(HttpClient);

  async fetchCsrfToken(): Promise<void> {
    try {
      await firstValueFrom(
        this.http.get(`${environment.apiBaseUrl}/auth/csrf-token`, {
          withCredentials: true,
        }),
      );
    } catch {
      console.warn("Failed to fetch CSRF token on init");
    }
  }
}
